import { Link } from 'react-router-dom';
import { Facebook, Instagram, Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-stone-900 text-white pt-16 pb-8" style={{ backgroundColor: '#1C2526' }}>
      <div className="container mx-auto px-4 md:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Card 1: About */}
          <div className="bg-stone-800 border-stone-700 rounded-3xl shadow-md transition-all duration-300 hover:shadow-[0_0_15px_rgba(240,90,40,0.5)] hover:border-[rgb(240,90,40)]" style={{ backgroundColor: '#2D3536' }}>
            <div className="p-6">
              <h3 className="font-display text-xl font-bold mb-4" style={{ color: 'rgb(233,58,31)' }}>
                <Link to="/" className="hover:text-[rgb(240,90,40)] transition-colors">
                  Žar & Bar Polskava
                </Link>
              </h3>
              <p className="text-stone-300 mb-4">
                Avtentična slovenska kulinarika z modernim pridihom. 
                Vrhunski žar in izbrana ponudba pijač v prijetnem ambientu.
              </p>
              <div className="flex space-x-3">
                <a 
                  href="https://facebook.com" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  aria-label="Facebook" 
                  className="bg-stone-700 p-2 rounded-full hover:bg-[rgb(240,90,40)] transition-colors"
                >
                  <Facebook size={18} className="text-white" />
                </a>
                <a 
                  href="https://instagram.com" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  aria-label="Instagram" 
                  className="bg-stone-700 p-2 rounded-full hover:bg-[rgb(240,90,40)] transition-colors"
                >
                  <Instagram size={18} className="text-white" />
                </a>
                <a 
                  href="mailto:info@zar-bar-polskava.si" 
                  aria-label="Email" 
                  className="bg-stone-700 p-2 rounded-full hover:bg-[rgb(240,90,40)] transition-colors"
                >
                  <Mail size={18} className="text-white" />
                </a>
              </div>
            </div>
          </div>

          {/* Card 2: Quick Links */}
          <div className="bg-stone-800 border-stone-700 rounded-3xl shadow-md transition-all duration-300 hover:shadow-[0_0_15px_rgba(240,90,40,0.5)] hover:border-[rgb(240,90,40)]" style={{ backgroundColor: '#2D3536' }}>
            <div className="p-6">
              <h3 className="font-display text-lg font-bold mb-4" style={{ color: 'rgb(233,58,31)' }}>Hitre povezave</h3>
              <ul className="space-y-2">
                <li>
                  <Link to="/" className="text-stone-300 hover:text-[rgb(240,90,40)] transition-colors">
                    Domača stran
                  </Link>
                </li>
                <li>
                  <Link to="/menu" className="text-stone-300 hover:text-[rgb(240,90,40)] transition-colors">
                    Meni
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="text-stone-300 hover:text-[rgb(240,90,40)] transition-colors">
                    O nas
                  </Link>
                </li>
                <li>
                  <Link to="/gallery" className="text-stone-300 hover:text-[rgb(240,90,40)] transition-colors">
                    Galerija
                  </Link>
                </li>
                <li>
                  <Link to="/events" className="text-stone-300 hover:text-[rgb(240,90,40)] transition-colors">
                    Dogodki
                  </Link>
                </li>
                <li>
                  <Link to="/contact" className="text-stone-300 hover:text-[rgb(240,90,40)] transition-colors">
                    Kontakt
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          {/* Card 3: Opening Hours */}
          <div className="bg-stone-800 border-stone-700 rounded-3xl shadow-md transition-all duration-300 hover:shadow-[0_0_15px_rgba(240,90,40,0.5)] hover:border-[rgb(240,90,40)]" style={{ backgroundColor: '#2D3536' }}>
            <div className="p-6">
              <h3 className="font-display text-lg font-bold mb-4" style={{ color: 'rgb(233,58,31)' }}>Delovni čas</h3>
              <ul className="space-y-2 text-stone-300">
                <li className="flex justify-between">
                  <span>Ponedeljek - Petek:</span>
                  <span>11:00 - 22:00</span>
                </li>
                <li className="flex justify-between">
                  <span>Sobota:</span>
                  <span>10:00 - 23:00</span>
                </li>
                <li className="flex justify-between">
                  <span>Nedelja:</span>
                  <span>10:00 - 22:00</span>
                </li>
              </ul>
            </div>
          </div>

          {/* Card 4: Contact */}
          <div className="bg-stone-800 border-stone-700 rounded-3xl shadow-md transition-all duration-300 hover:shadow-[0_0_15px_rgba(240,90,40,0.5)] hover:border-[rgb(240,90,40)]" style={{ backgroundColor: '#2D3536' }}>
            <div className="p-6">
              <h3 className="font-display text-lg font-bold mb-4" style={{ color: 'rgb(233,58,31)' }}>Kontakt</h3>
              <ul className="space-y-3 text-stone-300">
                <li className="flex items-start">
                  <MapPin size={18} className="mr-2 flex-shrink-0 mt-1" />
                  <span>Poljska cesta 12, 2314 Zgornja Polskava, Slovenija</span>
                </li>
                <li className="flex items-center">
                  <Phone size={18} className="mr-2 flex-shrink-0" />
                  <a href="tel:+38621234567" className="text-stone-300 hover:text-[rgb(240,90,40)] transition-colors">
                    +386 2 123 4567
                  </a>
                </li>
                <li className="flex items-center">
                  <Mail size={18} className="mr-2 flex-shrink-0" />
                  <a href="mailto:info@zar-bar-polskava.si" className="text-stone-300 hover:text-[rgb(240,90,40)] transition-colors">
                    info@zar-bar-polskava.si
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-stone-700 text-center text-stone-400 text-sm">
          <p>© {new Date().getFullYear()} Žar & Bar Polskava. Vse pravice pridržane.</p>
          <p className="mt-2 flex items-center justify-center gap-1">
            Made with 
            <span className="text-red-500 animate-pulse">❤️</span> 
            by 
            <a 
              href="https://digitalpro.dev/" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="text-[rgb(233,58,31)] hover:text-white transition-colors"
            >
              DigitalPro
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;